import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import AppShell from "./components/AppShell";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import Round from "./pages/Round";
import RoundSummary from "./pages/RoundSummary";
import Leagues from "./pages/Leagues";
import LeagueDetail from "./pages/LeagueDetail";
import Stats from "./pages/Stats";
import JoinLeague from "./pages/JoinLeague";
import JoinRound from "./pages/JoinRound";
import Watch from "./pages/Watch";
import Profile from "./pages/Profile";
import Leaderboard from "./pages/Leaderboard";
import TeamSeasons from "./pages/TeamSeasons";
import TeamSeasonDetail from "./pages/TeamSeasonDetail";
import ClubBag from "./pages/ClubBag";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Subscribe from "./pages/Subscribe";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import SwingLab from "./pages/SwingLab";
import SwingHistory from "./pages/SwingHistory";
import Promo from "./pages/Promo";
import { AdminLogin } from "./components/AdminLayout";

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicOnly><Landing /></PublicOnly>} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms" element={<Legal />} />
          <Route path="/terms-of-service" element={<Legal />} />
          <Route path="/privacy" element={<Legal />} />
          <Route path="/privacy-policy" element={<Legal />} />
          <Route path="/join/:code" element={<JoinLeague />} />
          <Route path="/watch" element={<Watch />} />
          {/* Public marketing promo — shareable video-like landing page */}
          <Route path="/promo" element={<Promo />} />

          {/* cPanel-style admin dashboard, separate from the mobile app */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/pricing" element={<Admin />} />
          <Route path="/admin/coupons" element={<Admin />} />
          <Route path="/admin/submissions" element={<Admin />} />
          <Route path="/admin/course-data" element={<Admin />} />
          <Route path="/admin/backups" element={<Admin />} />
          <Route path="/admin/domain" element={<Admin />} />
          <Route path="/admin/revenue" element={<Admin />} />

          <Route path="/app" element={<AppShell />}>
            <Route index element={<Dashboard />} />
            <Route path="courses" element={<Courses />} />
            <Route path="courses/:id" element={<CourseDetail />} />
            <Route path="round/:id" element={<Round />} />
            {/* Plural alias so /app/rounds/:id (matching /app/rounds/:id/summary
                and shared social links) doesn't 404. */}
            <Route path="rounds/:id" element={<Round />} />
            <Route path="rounds/:id/summary" element={<RoundSummary />} />
            <Route path="leagues" element={<Leagues />} />
            <Route path="leagues/:id" element={<LeagueDetail />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="seasons" element={<TeamSeasons />} />
            <Route path="seasons/:id" element={<TeamSeasonDetail />} />
            <Route path="stats" element={<Stats />} />
            <Route path="profile" element={<Profile />} />
            <Route path="profile/clubs" element={<ClubBag />} />
            <Route path="swing-lab" element={<SwingLab />} />
            <Route path="swings" element={<SwingHistory />} />
            <Route path="subscribe" element={<Subscribe />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
